export default "__VITE_PUBLIC_ASSET__9d1de52d__"